import { queryOptions } from "@tanstack/react-query";
import { getClinicianWorklist, getIncompleteDataDiaries, getWorklistConsents } from "./worklistApi";
import { listWorklistDismissals } from "./worklistDismissalsApi";
import { worklistKeys } from "./worklistKeys";

const worklistQueryConfig = {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
} as const;

export const clinicianWorklistQueryOptions = (userIds: string[] = []) =>
    queryOptions({
        queryKey: worklistKeys.forms(userIds),
        queryFn: () => getClinicianWorklist(userIds),
        ...worklistQueryConfig,
    });

export const incompleteDataDiariesQueryOptions = (userIds: string[] = []) =>
    queryOptions({
        queryKey: worklistKeys.incompleteData(userIds),
        queryFn: () => getIncompleteDataDiaries(userIds),
        ...worklistQueryConfig,
    });

export const worklistConsentsQueryOptions = (userIds: string[] = []) =>
    queryOptions({
        queryKey: worklistKeys.consents(userIds),
        queryFn: () => getWorklistConsents(userIds),
        ...worklistQueryConfig,
    });

export const worklistDismissalsQueryOptions = () =>
    queryOptions({
        queryKey: worklistKeys.dismissals(),
        queryFn: () => listWorklistDismissals(),
        ...worklistQueryConfig,
    });
